import Vue from 'vue';
import VueCompositionAPI, {
  computed,
  reactive,
} from '@vue/composition-api';

// We need to register it again because of Vue instance instantiation issues
Vue.use(VueCompositionAPI);

const state = reactive({
  isEditing: false,
  /**
   * @type {any}
   */
});

export const useSellerManagement = () => {
  const toggleEditing = () => {
    state.isEditing = !state.isEditing;
  };

  return {
    toggleEditing,
    isEditing: computed(() => state.isEditing),
  };
};
